import React, { createContext, useContext, useEffect, useState } from 'react';
import { Button, Card, Col, Flex, Row, Statistic, DatePicker } from 'antd';
import ViewByDay from "./ViewByDayChart"
import TopProduct from "./TopProduct"
import Orders from "./Orders"
import TopProductInCart from "./TopProductInCart"
import DahsboardReportService from "services/dashboard"
import dayjs from 'dayjs';
import RangePicker from "components/date-range-picker"
import { formatCurrency } from "utils/number"
import { formatDate } from "utils/date"
const service = new DahsboardReportService();
const WebsiteStatisticContext = createContext();

const WebsiteStatistic = () => {
  const { data, filter, setFilter } = useWebsiteStattistic();

  const setFilterValue = (name, value) => {

    var newFilter = { ...filter };
    newFilter[name] = value;
    setFilter(newFilter)
  }

  const onDateRangeFilterChange = (e) => {
    // e => setFilterValue("create_on", e)
    if (!e) {

      setFilterValue("range", null)
    } else {
      setFilterValue("range", {
        start: e[0].startOf("d").format(),
        end: e[1].endOf("d").format()
      })
    }

    console.log("e", e)
  }


  return (
    <Row gutter={[16, 16]}>
      <Col span={24}>
        <Flex justify='flex-end'>

          <div style={{ display: "flex", flexDirection: "column" }}>

            <RangePicker format={'DD/MM/YY'}

              presets={[
                { label: 'Hôm nay', value: [dayjs().add(0, 'd'), dayjs().add(0, 'd')] },
                { label: 'Hôm qua', value: [dayjs().add(-1, 'd'), dayjs().add(-1, 'd')] },
                { label: '7 ngày qua', value: [dayjs().add(-7, 'd'), dayjs().add(0, 'd')] },
                { label: '30 ngày qua', value: [dayjs().add(30, 'd'), dayjs().add(0, 'd')] },

              ]}

              value={filter.range ? [dayjs(filter.range.start), dayjs(filter.range.end)] : null}
              onChange={onDateRangeFilterChange} />

          </div>
        </Flex>

      </Col>
      <Col span={8}>
        <Card>
          <Statistic title="Lượt xem" value={data.views} />
        </Card>

      </Col>
      <Col span={8}>

        <Card>
          <Statistic title="Đơn hàng" value={data.order_count} />
        </Card>

      </Col>
      <Col span={8}>
        <Card>
          <Statistic title="Doanh số" value={data.order_amount} />
        </Card>
      </Col>

      {/* <Col span={12}>
        <Card title="Truy cập theo ngày" size='small'>
          <ViewByDay></ViewByDay>
        </Card>

      </Col> */}
      <Col span={12}>
        <Card title="Đơn hàng gần đây" size='small'>
          <Orders></Orders>
        </Card>
      </Col>

      <Col span={12}>
        <Card title="Top sản phẩm bán được " size='small'>
          <TopProductInCart></TopProductInCart>
        </Card>
      </Col>
    </Row>)
}


const WebsiteStatisticWrap = () => {

  const [data, setData] = useState({})


  const [filter, setFilter] = useState({
    range: {

      start: dayjs().add(-7, 'd').toDate(),
      end: dayjs().toDate(),

    }
  })




  useEffect(() => {
    loadData();
  }, [filter])

  const loadData = async () => {
    var range = null;

    if (filter.range) {
      range = {
        start: filter.range.start,
        end: filter.range.end,
      }
    }
    var dt = await service.dashboard({ range: range });
    setData(dt);
  }
  return (
    <WebsiteStatisticContext.Provider value={{ data: data, filter, setFilter }}>
      <WebsiteStatistic>

      </WebsiteStatistic>
    </WebsiteStatisticContext.Provider>
  )


}


const useWebsiteStattistic = () => {
  return useContext(WebsiteStatisticContext)
}

export { useWebsiteStattistic }
export default WebsiteStatisticWrap;